import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import ReactSelect, { components } from "react-select";

import PropTypes from "prop-types";
import React from "react";
import classes from "./DropDown.module.css";
import { mergeClass } from "../../utils/helper";

const DropDown = ({
  options = [],
  label = "",
  customStyle = {},
  disabled = false,
  value = "",
  setValue = () => {},
  placeholder = "Please Select",
  isMulti = false,
  style = {},
  leftIcon,
  Components = {},
  labelClassName = "",
  indicatorColor = "var(--gray-v4)",
  optionLabel,
  optionValue,
  getOptionLabel,
  selectRef,
  isSearchable = true,
  borderRadius = "7px",
  classNamePrefix,
  variant = "",
  errorText = "",
  mainClass = "",
  errorTextClass = "",
  dropDownContainer = "",
  dropDownClass = "",
  menuPlacement,
  onChange = null,
  showGradientBorder,
  required = true,
  height = 32,
  ...props
}) => {
  const DropdownIndicator = (props) => {
    const {
      selectProps: { menuIsOpen },
    } = props;

    return (
      <components.DropdownIndicator {...props}>
        {menuIsOpen ? (
          <IoIosArrowUp size={16} color={indicatorColor} />
        ) : (
          <IoIosArrowDown size={16} color={indicatorColor} />
        )}
      </components.DropdownIndicator>
    );
  };

  const dropDownStyle = {
    container: (provided) => ({
      ...provided,
      height: height,
    }),
    control: (base, state) => ({
      ...base,
      minHeight: height,
      height: height,
      border: state.isDisabled
        ? "0.5px solid var(--gray-v5)"
        : "0.5px solid var(--blue-dark)",
      boxShadow: "none",
      backgroundColor: "var(--white-color)",
      borderRadius: "5px",
      cursor: "pointer",
      fontFamily: "var(--inter)",
      fontSize: "16px",
      fontWeight: "300",
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      "&:hover": {
        border: state.isDisabled
          ? "0.5px solid var(--gray-v5)"
          : "0.5px solid var(--blue-dark)",
      },
    }),
    valueContainer: (base, state) => ({
      ...base,
      height: height,
    }),
    indicatorsContainer: (base, state) => ({
      ...base,
      height: height,
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "var(--black-color)",
        textTransform: "capitalize",
      };
    },

    option: (styles, { isSelected }) => {
      return {
        ...styles,
        padding: "8px 12px",
        fontWeight: 400,
        fontSize: 14,

        ":active": {
          ...styles[":active"],
        },

        ":hover": {
          ...styles[":hover"],
          color: "black",
          backgroundColor: "var(--white-color-v3)",
          cursor: "pointer",
        },
      };
    },

    input: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      height: height - 8,
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "var(--light-blue)",
        borderRadius: "8px",
        padding: "4px 8px",
        fontWeight: 500,
        height: height - 8,
      };
    },
    singleValue: (styles) => {
      return {
        ...styles,
        fontSize: 15,
        fontWeight: 500,
      };
    },
    multiValueLabel: (base) => {
      const fontSize = Math.max(height / 2.5, 6);
      return {
        ...base,
        padding: 2,
        fontSize: fontSize,
      };
    },
    multiValueRemove: (styles) => ({
      ...styles,
      fontSize: 12,
      color: "var(--white-color)",
      ":hover": {
        color: "var(--black-color)",
      },
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 9998,
    }),
  };
  return (
    <div>
      <div
        className={`${[classes.Container, mainClass].join(" ")}`}
        data-variant={variant}
      >
        <style>{`
        .DropdownOptionContainer__menu {
          margin: 0px;
          border: 0px;
          
        }
        .DropdownOptionContainer__single-value {
          color: var(--black-color)
        }
        .DropdownOptionContainer__menu {
          box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.08);
            padding:0px !important;
        } 
        .css-1ibgexp-control, .css-1ij4jul-control{
          padding:0px !important;
        }
        .css-1nmdiq5-menu{
          margin-top : 4px
          
        }
        .css-qr46ko{
          padding-top:0px;
          padding-bottom: 0px;
        }
        .css-11l7uqu-control, .css-zoephp-control,  .css-1fksnul-control, .css-14izoss-control{
            padding: 0px !important;
        } 
        .css-1xc3v61-indicatorContainer, .css-15lsz6c-indicatorContainer{
              align-items: center;
              padding: 0px 5px 0px 0px !important;
        }
        .css-31g5ko {
          padding: 0 8px;
        }
        .css-1a2ag6u {
          padding: 0;
          margin: 0;
        }
      `}</style>
        {label && (
          <label
            htmlFor={`dropdown${label} fw-300`}
            className={`${[
              classes.label,
              labelClassName && labelClassName,
              disabled && classes.disabled,
            ].join(" ")}`}
          >
            {label}
            {required && <span className="ml-1 text-red-500">*</span>}
          </label>
        )}

        <div
          className={mergeClass(dropDownContainer, classes.dropdownContainer)}
        >
          <ReactSelect
            inputId={`dropdown${label}`}
            value={value}
            onChange={
              onChange ??
              ((e) => {
                setValue(e);
              })
            }
            // menuIsOpen
            menuPlacement={menuPlacement}
            className={`${[classes.reactSelect, dropDownClass].join(" ")}`}
            isMulti={isMulti}
            isDisabled={disabled}
            placeholder={placeholder}
            options={options}
            styles={{ ...dropDownStyle, ...style }}
            isClearable={false}
            isSearchable={isSearchable}
            classNamePrefix={`DropdownOptionContainer ${
              classNamePrefix && classNamePrefix
            }`}
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator: (e) => DropdownIndicator(e),
              ...Components,
            }}
            getOptionLabel={
              getOptionLabel
                ? getOptionLabel
                : (option) => {
                    return optionLabel ? option[optionLabel] : option.label;
                  }
            }
            getOptionValue={(option) =>
              optionValue ? option[optionValue] : option.value
            }
            ref={selectRef}
            {...props}
          />
          {leftIcon && <div className={classes.leftIconBox}>{leftIcon}</div>}
          {errorText && (
            <p
              className={`mt-2 ${[classes.errorText, errorTextClass].join(
                " "
              )}`}
            >
              {errorText}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

DropDown.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  labelTwo: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.string,
  ]),
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  customStyle: PropTypes.object,
  style: PropTypes.object,
  Components: PropTypes.object,
  labelClassName: PropTypes.string,
};

export default DropDown;
